import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import CommonIcons from "../../../assets/icons";
import UnifiedDynamicForm from "../../../components/VMRS/ExploreTasking/components/form/UnifiedDynamicForm";
import { checkTypeImageIncludeProvider } from "./ultis";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

interface SatelliteSearchPanelProps
{
   imageType: any;
   setImageType: (val: any) => void;
   handleSearch: () => void;
   showBackToResultSearch: boolean;
   setShowResultSearch: (val: boolean) => void;
   providers: any;
   imageTypes: any[];
   formConfig?: any;
   formData: Record<string, any>;
   setFormData: (data: any) => void;
   setProviders: (providers: any) => void;
   setProviderCode: (providerCode: any) => void;
   setProviderId: (providerId: any) => void;
}

export default function SatelliteSearchPanel(props: SatelliteSearchPanelProps)
{
   const { t } = useTranslation();

   const {
      imageType,
      setImageType,
      handleSearch,
      showBackToResultSearch,
      setShowResultSearch,
      providers,
      imageTypes,
      formConfig,
      formData,
      setFormData,
      setProviders,
      setProviderCode,
      setProviderId,
   } = props;

   // Prepare step object for UnifiedDynamicForm if formConfig is available
   const step = formConfig
      ? {
         schema: formConfig.form_schema?.schema,
         ui: formConfig.ui_schema?.ui,
      }
      : null;

   const allAOI = useSelector((state: RootState) => state.aoi.features);

   const tooltipTitle =
      allAOI?.length === 0
         ? t("Please draw an area of interest.")
         : (!providers || providers.length === 0)
            ? t("No providers available for the selected image type.")
            : undefined;



   return (
      <div className="w-full !bg-[var(--neutral-1000)] text-[var(--color-main-text)] py-5 h-full relative">
         <div>
            {/* Title */}
            <div className="flex justify-between px-6">
               <span className="text-lg font-semibold mb-4">
                  {t("Search & Order Satellite Images")}
               </span>

               {showBackToResultSearch && (
                  <span onClick={() => setShowResultSearch(true)}>
                     <Tooltip title={t("Back to search result")}>
                        <div className="cursor-pointer">
                           <CommonIcons.DismissIcon />
                        </div>
                     </Tooltip>
                  </span>
               )}
            </div>

            {/* Image Type */}
            <div className="mb-5 px-6">
               <p className="text-sm mb-3 text-gray-300">{t("Image Type")}</p>

               <div className="flex gap-2 justify-between">
                  {imageTypes?.map((item: any, index: number) => (
                     <Tooltip
                        title={
                           checkTypeImageIncludeProvider(item)?.length > 0
                              ? ""
                              : t(
                                 "There is currently no provider that offers this type of photo.",
                              )
                        }
                     >
                        <div
                           key={index}
                           onClick={() =>
                           {
                              if (checkTypeImageIncludeProvider(item)?.length > 0)
                              {
                                 setImageType(item?.value);
                                 setProviders(checkTypeImageIncludeProvider(item));
                                 setProviderCode(
                                    checkTypeImageIncludeProvider(item)?.[0]?.code,
                                 );
                                 setProviderId(
                                    checkTypeImageIncludeProvider(item)?.[0]?.id,
                                 );
                              }
                           }}
                           className={
                              "div-type-image " +
                              (imageType === item?.value ? "div-type-image-active" : "")
                           }
                           style={{
                              cursor:
                                 checkTypeImageIncludeProvider(item)?.length > 0
                                    ? "pointer"
                                    : "not-allowed",
                           }}
                        >
                           {item?.label}
                        </div>
                     </Tooltip>
                  ))}
               </div>
            </div>

            {/* Dynamic Form or Hardcoded Fallback */}
            {formConfig && step && (
               <UnifiedDynamicForm
                  step={step}
                  formData={formData}
                  setFormData={setFormData}
                  type="add"
                  display="col"
                  disablePastDates={false} // archive: only past dates allowed
               />
            )}
         </div>

         {/* Button */}
         <div
            className="flex absolute bottom-0 w-full justify-end px-6  py-4"
            style={{ borderTop: "1px solid var(--divider-1)" }}
         >
            <span className="w-[151px] block">
               <Tooltip
                  title={tooltipTitle
                  }
               >
                  <Button
                     onClick={() =>
                     {
                        if (!tooltipTitle) handleSearch();
                     }}
                     // disabled={false}
                     className={`w-full !border-none ${tooltipTitle
                        ? "opacity-50 cursor-not-allowed"
                        : "!bg-[var(--primary-4)] text-[var(--primary-950)]"
                        }`}
                  >
                     {t("Search Images")}
                  </Button>
               </Tooltip>
            </span>
         </div>
      </div>
   );
}
